<template>
  <div class="Bgc-white">
    <Header />
    <div class="container padding-custom">
      <div class="row">
        <div class="col-12">
          <h2 class="mb-4">{{ title }}</h2>

          <div class="row" v-if="!nuevoPerfil">
            <div class="col-sm-12 col-lg-6 pb-3">
              <span class="link pointer bold"
                @click="CrearNuevoPerfil(); infoPersonal.perfilDado = ''; enableProfiles = true">
                <i class="icon-user-add"></i>
                {{ $t('language.posadasCorporate.perfilHuespedes.nuevoPerfil') }}
              </span>
            </div>
            <div class="col-sm-12 col-lg-6">
              <div class="contenidoSearch custom-inputsearch" :id="field.key" v-for="field in fields" :key="field.key">
                <i class="icon-search"></i>
                <input v-model="filters[field.key]"
                  :placeholder="$t('language.posadasCorporate.perfilHuespedes.buscarPerfil')" />
              </div>
            </div>
          </div>

          <div class="relative" v-if="!nuevoPerfil">
            <span class="pointer checkAll" v-if="!enableLoaderTable">
              <i class="icon-checkbox-inactive" v-if="selected.length == 0 || selected.length <= perPage - 1"
                @click="selectAllRows"></i>
              <i class="link icon-checkbox-active" v-if="selected.length >= perPage" @click="UnselectAllRows"></i>
            </span>

            <span class="multiDelete" v-if="!enableLoaderTable">
              <span class="bold"
                v-if="selected.length === 0 || selected.length <= 1">{{ $t('language.posadasCorporate.perfilHuespedes.table.opciones') }}</span>
              <span @click="showModalMultiDelete" class="bold link pointer"
                v-else>{{ $t('language.posadasCorporate.perfilHuespedes.eliSeleccion') }}</span>
            </span>
            <Loader v-if="enableLoaderTable" />
            <b-table ref="selectableTable" v-if="!enableLoaderTable" selectable show-empty
              :empty-text="$t('language.posadasCorporate.politicasViaje.noRegistros')" :select-mode="selectMode"
              @row-selected="onRowSelected" striped responsive :fields="fields" :items="filtered"
              :current-page="currentPage" :per-page="perPage">
              <span slot="[name]" slot-scope="data" v-html="data.value"></span>
              <span slot="[options]" slot-scope="data" v-html="data.value"></span>

              <template v-slot:cell(selected)="{ rowSelected }">
                <template v-if="rowSelected">
                  <i class="link icon-checkbox-active"></i>
                </template>
                <template v-else>
                  <i class="icon-checkbox-inactive"></i>
                </template>
              </template>
              <!-- Nombre -->
              <template v-slot:cell(name)="row">
                <span>
                  {{ row.item.name }}
                </span>
              </template>
              <!-- Acciones -->
              <template v-slot:cell(options)="row">
                <span class="link cursor-pointer"
                  @click="modificarPerfil(row); pickedTelelefono = ''; readyUpdate = true; enableProfiles = false">
                  <i v-b-popover.hover.top="$t('language.posadasCorporate.perfilHuespedes.table.editPerfil')"
                    class="icon-avanzada icon-edit"></i>
                </span>
                <span v-if="row.item.visible" class="link cursor-pointer" @click="showModalEliminar(row)">
                  <i v-b-popover.hover.top="$t('language.posadasCorporate.perfilHuespedes.table.eliminar')"
                    class="icon-avanzada icon-trash"></i>
                </span>
              </template>
            </b-table>
            <b-pagination v-if="filtered.length >= perPage" v-model="currentPage" :total-rows="items.length"
              :per-page="perPage" align="right" size="sm" />
          </div>

          <!-- Nuevo Perfil/Modificar perfil del huesped -->
          <div v-if="nuevoPerfil">
            <form @submit.prevent>
              <div class="datos">
                <!-- dato 1 -->
                <div class="dato">
                  <!-- Datos personales -->
                  <div class="campos">
                    <p class="tituloDatos" v-if="infoPersonal.datosPersonales"
                      :class="(infoPersonal.iconoActivo == 0) ? 'camposActive' : ''"
                      @click="(infoPersonal.iconoActivo == 0) ? infoPersonal.iconoActivo = 100 : infoPersonal.iconoActivo = 0"
                      v-b-toggle="'datosPersonales'">
                      <i class="icon-user"></i>
                      {{ $t('language.posadasCorporate.perfilHuespedes.datosPersonales') }}
                      <i class="navi icon-up" :class="(infoPersonal.iconoActivo == 0) ? '' : 'oculto'"></i>
                      <i class="navi icon-navigate-down" :class="(infoPersonal.iconoActivo == 0) ? 'oculto' : ''"></i>
                    </p>
                    <p class="tituloDatosEditar" v-if="!infoPersonal.datosPersonales"
                      @click="(infoPersonal.iconoActivo == 0) ? infoPersonal.iconoActivo = 100 : infoPersonal.iconoActivo = 0"
                      v-b-toggle="'datosPersonales'">
                      <i class="icon-check-rounded-fill"></i>
                      {{ $t('language.posadasCorporate.perfilHuespedes.datosPersonales') }}
                      <span class="editarDatos pointer"
                        @click="[infoPersonal.datosPersonales = true]">{{ $t('language.posadasCorporate.perfilHuespedes.editar') }}</span>
                    </p>
                    <!-- Formulario -->
                    <b-collapse class="datos" id="datosPersonales" v-model="visible" accordion="my-accordion"
                      role="tabpanel">
                      <!-- PROFILES -->
                      <div class="row segundaIlera">
                        <!-- Nombre -->
                        <div class="form-element col-12 col-lg-4">
                          <label for="">{{ $t('language.posadasCorporate.perfilHuespedes.nombre') }}*</label>
                          <input type="text" v-model="realNome" class="inputUppercase" maxlength="26">
                        </div>
                        <div class="form-element col-6 col-lg-4">
                          <label for="">{{ $t('language.posadasCorporate.perfilHuespedes.apePaterno') }}*</label>
                          <input type="text" v-model="realApelhedo" class="inputUppercase" maxlength="26">
                        </div>
                        <div class="form-element col-6 col-lg-4">
                          <label for="">{{ $t('language.posadasCorporate.perfilHuespedes.apeMaterno') }}</label>
                          <input type="text" v-model="realApelhedoMae" class="inputUppercase" maxlength="26">
                        </div>
                        <!-- informacion empresa -->
                        <div class="form-element col-12 col-lg-3">
                          <label for="">{{ $t('language.posadasCorporate.perfilHuespedes.numEmpAgente') }}</label>
                          <input type="text" :placeholder="$t('language.posadasCorporate.generals.caracteresMax20')"
                            v-model="realNumeroEmple" class="inputUppercase" maxlength="20">
                        </div>
                        <div class="form-element col-6 col-lg-3">
                          <label for="">{{ $t('language.posadasCorporate.perfilHuespedes.numeroFR') }}</label>
                          <input type="text" :placeholder="$t('language.posadasCorporate.generals.caracteresMax12')"
                            v-model="realNumeroFiesta" class="inputUppercase" maxlength="12">
                        </div>
                        <div class="form-element col-6 col-lg-3">
                          <label for="">{{ $t('language.posadasCorporate.perfilHuespedes.numApreClub') }}</label>
                          <input type="text" :placeholder="$t('language.posadasCorporate.generals.caracteresMax18')"
                            maxlength="18" v-model="realNumeroApreciare" class="inputUppercase">
                        </div>
                        <div class="form-element col-12 col-lg-3">
                          <label for="">{{ $t('language.posadasCorporate.perfilHuespedes.controCostos') }}</label>
                          <input type="text"
                            :placeholder="$t('language.posadasCorporate.perfilHuespedes.maxCaracter20')" maxlength="20"
                            v-model="realNumeroCentro" class="inputUppercase">
                        </div>
                        <div class="col-12">
                          <label for=""
                            class="notas">*{{ $t('language.posadasCorporate.perfilHuespedes.camposRequeridos') }}</label>
                        </div>

                        <!-- Boton -->
                        <div class="col-sm-12 col-lg-6 botonesInfo" v-b-toggle="'datosPersonales'"
                          v-b-toggle.datosContacto>
                          <button class="button" :disabled="isDisabledPersonales"
                            @click="[infoPersonal.datosPersonales = false, infoPersonal.datosContacto = true]">
                            {{ $t('language.posadasCorporate.perfilHuespedes.contDatContacto') }}
                          </button>
                        </div>
                      </div>
                    </b-collapse>
                  </div>

                  <!-- Datos de contacto -->
                  <div class="campos">
                    <p class="tituloDatos" v-if="infoPersonal.datosContacto"
                      :class="(infoPersonal.iconoActivo == 2) ? 'camposActive' : ''"
                      @click="(infoPersonal.iconoActivo == 2) ? infoPersonal.iconoActivo = 200 : infoPersonal.iconoActivo = 2"
                      v-b-toggle="'datosContacto'" accordion="my-accordion" role="tabpanel">
                      <i class="icon-location"></i>
                      {{ $t('language.posadasCorporate.perfilHuespedes.datosContacto') }}
                      <i class="navi icon-up" :class="(infoPersonal.iconoActivo == 2) ? '' : 'oculto'"></i>
                      <i class="navi icon-navigate-down" :class="(infoPersonal.iconoActivo == 2) ? 'oculto' : ''"></i>
                    </p>
                    <p class="tituloDatosEditar" v-if="!infoPersonal.datosContacto"
                      @click="(infoPersonal.iconoActivo == 2) ? infoPersonal.iconoActivo = 200 : infoPersonal.iconoActivo = 2"
                      v-b-toggle="'datosContacto'">
                      <i class="icon-check-rounded-fill"></i>
                      {{ $t('language.posadasCorporate.perfilHuespedes.datosContacto') }}
                      <span class="editarDatos pointer"
                        @click="[infoPersonal.datosContacto = true]">{{ $t('language.posadasCorporate.perfilHuespedes.editar') }}</span>
                    </p>

                    <!-- Formulario -->
                    <b-collapse class="datos" id="datosContacto" accordion="my-accordion" role="tabpanel">
                      <div class="row contactoInfo">

                        <!-- Tipo de teléfono -->
                        <div class="form-element col-12 col-lg-6">
                          <label>{{ $t('language.posadasCorporate.perfilHuespedes.tipoTelefono') }}*</label><br>
                          <label for="celular" class="col-4 pl-0 radio">
                            <input type="radio" id="celular" class="hidden" value="MOB" v-model="pickedTelelefono">
                            <span class="label"></span><span
                              class="moneda">{{ $t('language.posadasCorporate.perfilHuespedes.celular') }}</span>
                          </label>
                          <label for="casa" class="col-4 pl-0 radio">
                            <input type="radio" id="casa" class="hidden" value="HOM" v-model="pickedTelelefono">
                            <span class="label"></span><span
                              class="moneda">{{ $t('language.posadasCorporate.perfilHuespedes.casa') }}</span>
                          </label>
                          <label for="oficina" class="col-4 pl-0 radio">
                            <input type="radio" id="oficina" class="hidden" value="BUS" v-model="pickedTelelefono">
                            <span class="label"></span><span
                              class="moneda">{{ $t('language.posadasCorporate.perfilHuespedes.oficima') }}</span>
                          </label>
                        </div>

                        <!-- Núm. telefónico Oficina-->
                        <div class="form-element col-12 col-lg-6">
                          <label>{{ $t('language.posadasCorporate.perfilHuespedes.numTelefonico') }}*</label>
                          <!--
                            <input type="number" :placeholder="$t('language.posadasCorporate.perfilHuespedes.digitos10')" :value="infoPersonal.numTelefonicoOficina" @input="updateValue" onkeypress="return event.key === 'Enter' || (Number(event.key) >= 0 && Number(event.key) <= 9)"   >  v-onlyNumbers maxlength="20" -->
                          <!-- KB47296 Start -->
                          <vue-tel-input :value="infoPersonal.numTelefonicoOficina"
                            @validate="handleValidatePhoneNumber" @input="handleOnInputPhoneNumber"
                            @blur="handleOnBlurPhoneNumber" @country-changed="handleCountryChanged" :key="telInput"></vue-tel-input>
                          <!-- KB47296 End -->
                        </div>

                        <!-- Correo electrónico* -->
                        <div class="form-element col-6 col-lg-4">
                          <label for="">{{ $t('language.posadasCorporate.perfilHuespedes.email') }}*</label>
                          <input type="text"
                            :placeholder="$t('language.posadasCorporate.perfilHuespedes.ejemplo') + '@' + $t('language.posadasCorporate.perfilHuespedes.correo') + '.com'"
                            v-model="mailContacto" v-email maxlength="50"
                            :class="{ 'is-invalid': (!$v.mailContacto.email) }">
                          <span class="notas"
                            v-if="!$v.mailContacto.email">{{ $t('language.posadasCorporate.perfilHuespedes.emailNoValido') }}</span>
                        </div>

                        <div class="form-element col-6 col-lg-4">
                          <label
                            for="">{{ $t('language.posadasCorporate.tablaUsuariosRegistrados.editarInfo.confEmail') }}*</label>
                          <input type="text"
                            :placeholder="$t('language.posadasCorporate.tablaUsuariosRegistrados.editarInfo.ejemplo') + '@' + $t('language.posadasCorporate.tablaUsuariosRegistrados.editarInfo.correo') + '.com'"
                            v-model="mailContactoConfirm" v-email maxlength="50"
                            :class="{ 'is-invalid': (!$v.mailContactoConfirm.email || !emailMatch) }">
                          <span class="notas"
                            v-if="!$v.mailContactoConfirm.email">{{ $t('language.posadasCorporate.tablaUsuariosRegistrados.editarInfo.emailInvalid') }}.</span>
                          <span class="notas" v-if="!emailMatch">
                            {{ $t('language.posadasCorporate.tablaUsuariosRegistrados.editarInfo.emailCopy') }}.
                          </span>
                        </div>

                        <div class="form-element col-6 col-lg-4">
                          <label for="">{{ $t('language.posadasCorporate.perfilHuespedes.sendCopyConfi') }}</label>
                          <input type="text"
                            :placeholder="$t('language.posadasCorporate.perfilHuespedes.ejemplo') + '@' + $t('language.posadasCorporate.perfilHuespedes.correo') + '.com'"
                            v-model="infoPersonal.mailContactoConfirmacion" v-email maxlength="50"
                            :class="{ 'is-invalid': (!$v.infoPersonal.mailContactoConfirmacion.email) }">
                          <span class="notas"
                            v-if="!$v.infoPersonal.mailContactoConfirmacion.email">{{ $t('language.posadasCorporate.perfilHuespedes.emailNoValido') }}</span>
                          <span class="notas">{{ $t('language.posadasCorporate.perfilHuespedes.copy1Confi') }}:
                            reservacionescorporate@posadas.com</span>
                        </div>

                        <!-- direccion -->
                        <!-- tipo direccion -->
                        <div class="form-element col-12">
                          <label
                            class="detalle-usuario__subtitulo PC-text--size16">{{ $t('language.posadasCorporate.reservacionesRegistro.newAddress') }}</label><br>
                        </div>


                        <!-- Calle numero -->
                        <div class="form-element col-8 col-lg-6">
                          <label for="">{{ $t('language.posadasCorporate.perfilHuespedes.calleNumero') }}</label>
                          <input type="text" v-model="realAddress" class="inputUppercase" maxlength="50">
                        </div>
                        <div class="form-element col-6 col-lg-3">
                          <label for="">{{ $t('language.posadasCorporate.perfilHuespedes.colonia') }}</label>
                          <input type="text" v-model="realTown" class="inputUppercase" maxlength="50">
                        </div>

                        <!-- Código Postal -->
                        <div class="form-element col-4 col-lg-3">
                          <label for="">{{ $t('language.posadasCorporate.perfilHuespedes.codigoPostal') }}</label>
                          <input type="text" v-model="realZip" maxlength="10" class="inputUppercase">
                        </div>

                        <!-- Pais -->
                        <div class="form-element  col-lg-3" v-click-outside="outsidePais">
                          <label>{{ $t('language.posadasCorporate.perfilHuespedes.pais') }}*</label>
                          <div class="contenidoSearch" @click="[infoPersonal.pais = true]">
                            <i class="search-icons icon-search" v-if="!infoPersonal.pais"></i>
                            <i class="search-icons icon-close pointer" v-if="infoPersonal.pais"
                              @click="realCountry = '', resetSelectedPais()"></i>
                            <input class="elipse" type="text"
                              :placeholder="$t('language.posadasCorporate.perfilHuespedes.seleccionar')"
                              @click="filteredListPaises"  v-model="realCountry">
                          </div>

                          <div class="card buscadorCard vb" v-if="infoPersonal.pais" v-bar>
                            <div>
                              <div class="buscador" v-for="pais in filteredListPaises" :key="pais.id">
                                <p class="mb-1 nombre" @click="[cambiaPais(pais.nombre), infoPersonal.pais = false]"
                                  v-html="$options.filters.resalt(pais.nombre, realCountry)">
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- Estado -->
                        <div class="form-element  col-lg-3" v-click-outside="outsideEstado">
                          <label for="">{{ $t('language.posadasCorporate.perfilHuespedes.estado') }}</label>
                          <div class="contenidoSearch">
                            <i class="search-icons icon-search" v-if="!infoPersonal.estado"></i>
                            <i class="search-icons icon-close pointer" v-if="infoPersonal.estado"
                              @click="infoPersonal.estadoSeleccionado = ''"></i>
                            <input class="elipse" type="text"
                              :placeholder="$t('language.posadasCorporate.perfilHuespedes.seleccionar')"
                              :disabled="isDisabledEstado" @click="infoPersonal.estado = true; filteredListEstado()"
                              v-model="infoPersonal.estadoSeleccionado">
                          </div>

                          <div class="card buscadorCard vb" v-if="infoPersonal.estado" v-bar>
                            <div>
                              <div class="buscador" v-for="estado in filteredListEstado" :key="estado.id">
                                <p class="mb-1 nombre"
                                  @click="[cambiaEstado(estado.nombre), infoPersonal.estado = false]"
                                  v-html="$options.filters.resalt(estado.nombre, infoPersonal.estadoSeleccionado)">
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- Ciudad -->
                        <div class="form-element  col-lg-3">
                          <label for="">{{ $t('language.posadasCorporate.perfilHuespedes.ciudad') }}</label>
                          <input type="text" v-model="realCity" class="inputUppercase" maxlength="50">
                        </div>

                        <div class="col-12 mb-2">
                          <label for=""
                            class="notas">*{{ $t('language.posadasCorporate.perfilHuespedes.camposRequeridos') }}</label>
                        </div>
                      </div>
                    </b-collapse>
                  </div>
                </div>
                <span>
                  {{ $t('language.posadasCorporate.perfilHuespedes.conocerMas') }}
                  <a class="link pointer bold" @click="avisoPrivacidad" onclick="return false;"
                    href="#">{{ $t('language.posadasCorporate.perfilHuespedes.avisoPrivacidad') }}</a>
                </span>
              </div>
              <Loader v-if="enableLoader" />
              <!-- Botones -->
              <div class="row botones d-flex justify-content-end mt-4">
                <div class="col-12 col-lg-4 order-2 order-lg-1">
                  <button class="secondary-button"
                    @click="nuevoPerfil = false, clearForm(), title = $t('language.posadasCorporate.perfilHuespedes.perfilHuespedes')">{{ $t('language.posadasCorporate.perfilHuespedes.regresar') }}</button>
                </div>
                <div class="col-12 col-lg-4 order-1 order-lg-2 mb-2 mb-lg-0">
                  <button :disabled="isDisabledContacto" class="button"
                    @click="createNewProfile()">{{ buttonSave }}</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Guardar -->
    <modal v-show="isModalGuardar" @close="closeModalGuardar" maxWidth="max-w-500">
      <template slot="header">
        <b class="verde mt-2 pt-3"> <i class="demo-icon icon-check-rounded-fill Fw-bolder"></i>
          {{ modalTitle }}
        </b>
      </template>
      <template slot="body">
        <p class="Ta-left">
          {{ modalBody }}
        </p>
      </template>
      <template slot="footer">
        <button type="button" class="button btn-primary order-1 order-lg-2 botonesSoloadultos"
          @click="closeModalGuardar" aria-label="Close modal">
          {{ $t('language.posadasCorporate.perfilHuespedes.modalGuardar.entendido') }}
        </button>
      </template>
    </modal>

    <!-- Modal Eliminar -->
    <modal v-show="isModalEliminar" @close="closeModalEliminar" maxWidth="max-w-500 w-100">
      <template slot="header">
        <b class="danger mt-2 pt-3"> <i class="demo-icon icon-warning-fill Fw-bolder"></i>
          {{ $t('language.posadasCorporate.perfilHuespedes.modalEliminar.title1') }}
        </b>
      </template>
      <template slot="body">
        <p class="Ta-left">
          {{ $t('language.posadasCorporate.perfilHuespedes.modalEliminar.body1') }}
        </p>
      </template>
      <template slot="footer">
        <button type="button" class="button secondary-button order-1 order-lg-2 botonesSoloadultos"
          @click="closeModalEliminar" aria-label="Close modal">
          {{ $t('language.posadasCorporate.perfilHuespedes.modalEliminar.cancelar') }}
        </button>
        <button type="button" class="button btn-primary order-1 order-lg-2 botonesSoloadultos"
          @click="closeModalEliminarI(true, false)" aria-label="Close modal">
          {{ $t('language.posadasCorporate.perfilHuespedes.modalEliminar.eliPerfil') }}
        </button>
      </template>
    </modal>

    <!-- Modal Confirmación Eliminar -->
    <modal v-show="isModalConfirmacionEliminar" @close="closeModalConfirmacionEliminar" maxWidth="max-w-500 w-100">
      <template slot="header">
        <b class="verde mt-2 pt-3 pb-3"> <i class="demo-icon icon-check-rounded-fill Fw-bolder"></i>
          {{ $t('language.posadasCorporate.perfilHuespedes.modalEliminar.title2') }}
        </b>
      </template>
      <template slot="footer">
        <button type="button" class="button btn-primary order-1 order-lg-2 botonesSoloadultos"
          @click="closeModalConfirmacionEliminar" aria-label="Close modal">
          {{ $t('language.posadasCorporate.perfilHuespedes.modalEliminar.entendido') }}
        </button>
      </template>
    </modal>

    <!-- Modal Multi Eliminar -->
    <modal v-show="isModalMultiDelete" @close="isModalMultiDelete = false" maxWidth="max-w-500 w-100">
      <template slot="header">
        <b class="danger mt-2 pt-3"> <i class="demo-icon icon-warning-fill Fw-bolder"></i>
          {{ $t('language.posadasCorporate.perfilHuespedes.modalMultiEliminar.title1') }}
        </b>
      </template>
      <template slot="body">
        <p class="Ta-left">
          {{ $t('language.posadasCorporate.perfilHuespedes.modalMultiEliminar.body1') }}
        </p>
      </template>
      <template slot="footer">
        <button type="button" class="button secondary-button order-1 order-lg-2 botonesSoloadultos"
          @click="isModalMultiDelete = false" aria-label="Close modal">
          {{ $t('language.posadasCorporate.perfilHuespedes.modalMultiEliminar.cancelar') }}
        </button>
        <button type="button" class="button btn-primary order-1 order-lg-2 botonesSoloadultos"
          @click="closeModalMultiDelete" aria-label="Close modal">
          {{ $t('language.posadasCorporate.perfilHuespedes.modalMultiEliminar.eliPerfiles') }}
        </button>
      </template>
    </modal>

    <!-- Modal Confirmación Multi Eliminar -->
    <modal v-show="isModalConfirmMultiDelete" @close="closeModalConfirmMultiDelete" maxWidth="max-w-500 w-100">
      <template slot="header">
        <b class="verde mt-2 pt-3 pb-3"> <i class="demo-icon icon-check-rounded-fill Fw-bolder"></i>
          {{ $t('language.posadasCorporate.perfilHuespedes.modalMultiEliminar.title2') }}
        </b>
      </template>
      <template slot="footer">
        <button type="button" class="button btn-primary order-1 order-lg-2 botonesSoloadultos"
          @click="closeModalConfirmMultiDelete" aria-label="Close modal">
          {{ $t('language.posadasCorporate.perfilHuespedes.modalMultiEliminar.entendido') }}
        </button>
      </template>
    </modal>

    <!-- Modal Confirmación Multi Eliminar -->
    <modal v-show="isModalConfirmMultiDelete" @close="closeModalConfirmMultiDelete" maxWidth="max-w-500 w-100">
      <template slot="header">
        <b class="verde mt-2 pt-3 pb-3">
          <i class="demo-icon icon-check-rounded-fill Fw-bolder"></i>
          {{ $t('language.posadasCorporate.perfilHuespedes.modalMultiEliminar.title2') }}
        </b>
      </template>
      <template slot="footer">
        <button type="button" class="button btn-primary order-1 order-lg-2 botonesSoloadultos"
          @click="closeModalConfirmMultiDelete"
          aria-label="Close modal">{{ $t('language.posadasCorporate.perfilHuespedes.modalMultiEliminar.entendido') }}</button>
      </template>
    </modal>

    <!-- EXPIRED SESSION MODAL  -->
    <modal v-show="isExpiredModalVisible" @close="closeExpiredModal" maxWidth="max-w-500">
      <template slot="header">
        <b class="caution">
          <i class="demo-icon icon-warning-fill Fw-bolder"></i>
          {{ $t('language.posadasCorporate.modales.expiredSession.title') }}
        </b>
      </template>
      <template slot="body">
        <p class="Ta-left">{{ $t('language.posadasCorporate.modales.expiredSession.body') }}</p>
      </template>
      <template slot="footer">
        <button type="button" class="button btn-primary" @click="closeExpiredModal" aria-label="Close modal">{{
            $t('language.posadasCorporate.modales.expiredSession.button')
        }}</button>
      </template>
    </modal>
    <!-- EXPIRED SESSION MODAL  -->

    <Footer />
  </div>
</template>
<script>
import Header from "../../generales/Header.vue";
import Footer from "../../generales/Footer.vue";
import Mixin from "../../../mixins/commons.js";
import axios from "axios";
import Modal from "./../../addons/Modal.vue";
import SecureLS from "secure-ls";
import i18n from "../../../plugins/i18n";
import * as GlobalFunctions from "../../../utils/GlobalFunctions";
import * as GlobalServices from "../../../utils/GlobalServices";
import Loader from '../../loader/Loader'

//KB47296 Start
import { validatePhoneNumber } from "../../../utils/GlobalFunctions";
//KB47296 End

import { required, email } from "vuelidate/lib/validators";
export default {
  name: "BusquedaPorTarifa",
  components: {
    Header,
    Footer,
    Modal,
    Loader
  },
  mixins: [Mixin],
  mounted() {
    if (!GlobalFunctions.validIfGenericUser()) {
      this.dataTable();
    }
  },
  data: () => {
    return {
      telInput: 0,
      profileId: '',
      banSelectedPais: false,
      realNome: "",
      realApelhedo: "",
      realApelhedoMae: "",
      realAddress: "",
      realTown: "",
      realZip: "",
      realCity: "",
      realNumeroApreciare: "",
      realNumeroCentro: "",
      realNumeroFiesta: "",
      validRegex: /^[a-zA-Z\\d\\.\\1-9\\0\\ ]*$/,
      validRegexComma: /^[a-zA-Z\\d\\.\\1-9\\0\\ \\,]*$/,

      validRegexEMPLE: /^[a-zA-Z0-9-_\\ ]+$/,
      validRegexFR: /^[a-zA-Z0-9-_]+$/,
      realNumeroEmple: "",
      globalFunctions: GlobalFunctions,
      mailContacto: "",
      mailContactoConfirm: "",
      emailMatch: true,
      enableLoaderTable: false,
      editingPerfil: false,
      pickedTelelefono: "",
      cellNumber: "",
      officeNumber: "",
      homeNumber: "",
      filterSearch: "",
      realCountry: "",
      paisSeleccionado: "",
      estadoSeleccionado: "",
      selectedGuestProfileId: "",
      enableProfiles: false,
      enableLoader: false,
      readyUpdate: false,
      profileIdR: "",
      title: i18n.t('language.posadasCorporate.perfilHuespedes.perfilHuespedes'),
      buttonSave: i18n.t('language.posadasCorporate.perfilHuespedes.crearNuePerfil'),
      modalTitle: i18n.t('language.posadasCorporate.perfilHuespedes.modalGuardar.title1'),
      modalBody: i18n.t('language.posadasCorporate.perfilHuespedes.modalGuardar.body2'),
      countryCode: "",
      stateCode: "",
      titleCode: "",
      curProfile: [],
      isExpiredModalVisible: false,
      ls: new SecureLS({ encodingType: "aes" }),
      perPage: 7,
      currentPage: 1,
      fields: [
        {
          key: "selected",
          label: "",
          tdClass: "max-5",
          thClass: "max-5"
        },
        {
          key: "name",
          label: i18n.t('language.posadasCorporate.perfilHuespedes.table.nomPerfiles'),
          tdClass: "max-80",
          thClass: "max-80 th-font"
        },
        {
          key: "options",
          label: "",
          tdClass: "max-10",
          thClass: "max-10"
        }
      ],
      items: [],
      guestsWS: [],
      selectMode: "multi",
      selected: [],
      filters: {
        name: ""
      },
      isModalGuardar: false,
      isModalEliminar: false,
      isModalConfirmacionEliminar: false,
      isModalMultiDelete: false,
      isModalConfirmMultiDelete: false,
      tipoperfilCheck: "",
      nuevoPerfil: false,
      visible: true,
      infoPersonal: {
        perfiles: [
        ],
        perfilDado: "",
        perfil: false,
        //Activador de Icono
        iconoActivo: 0,
        tipoPerfil: true,
        // Datos
        datosPersonales: true,
        datosContacto: true,
        contrasena: true,
        // Titulo
        titulo: false,
        tituloDado: "",
        titulos: [
          {
            nombre: "Sr.",
            value: "2"
          },
          {
            nombre: "Sra.",
            value: "3"

          },
          {
            nombre: "Srita.",
            value: "4"

          }
        ],
        // tipos de telefono
        pickedTelelefono: '',
        // Nombre
        nombres: "",
        apellidoP: "",
        apellidoM: "",
        // Numeros
        numEmp: "",
        numFiesta: "",
        numApreciare: "",
        numCentro: "",
        numTelefonicoCel: "",
        numTelefonicoCasa: "",
        numTelefonicoOficina: "",
        // tipos de direccion
        pickedDireccion: '',
        direccion: "",
        colonia: "",
        codigoPostal: "",
        mailContacto: "",
        mailContactoCopia: "",
        mailContactoConfirmacion: "",
        //paises
        pais: false,
        paisSeleccionado: "",
        paises: [],
        //estados
        estado: "",
        estadoSeleccionado: "",
        estados: [],
        ciudad: ""
      }
    };
  },
  validations: {
    mailContacto: {
      required,
      email
    },
    mailContactoConfirm: {
      required,
      email
    },
    infoPersonal: {
      mailContacto: {
        required,
        email
      },
      mailContactoCopia: {
        required,
        email
      },
      mailContactoConfirmacion: {
        required,
        email
      }
    }
  },
  watch: {
    realNome() {
      let str = "";
      if (!this.validRegex.test(this.realNome)) {
        str = this.realNome.substring(0, this.realNome.length - 1);
        this.realNome = str
      }
    },
    realApelhedo() {
      let str = "";
      if (!this.validRegex.test(this.realApelhedo)) {
        str = this.realApelhedo.substring(0, this.realApelhedo.length - 1);
        this.realApelhedo = str
      }
    },
    realApelhedoMae() {
      let str = "";
      if (!this.validRegex.test(this.realApelhedoMae)) {
        str = this.realApelhedoMae.substring(0, this.realApelhedoMae.length - 1);
        this.realApelhedoMae = str
      }
    },
    realNumeroCentro() {
      let str = "";
      if (!this.validRegex.test(this.realNumeroCentro)) {
        str = this.realNumeroCentro.substring(0, this.realNumeroCentro.length - 1);
        this.realNumeroCentro = str
      }
    },
    realAddress() {
      let str = "";
      if (!this.validRegexComma.test(this.realAddress)) {
        str = this.realAddress.substring(0, this.realAddress.length - 1);
        this.realAddress = str
      }
    },
    realTown() {
      let str = "";
      if (!this.validRegexComma.test(this.realTown)) {
        str = this.realTown.substring(0, this.realTown.length - 1);
        this.realTown = str
      }
    },
    realZip() {
      let str = "";
      if (!this.validRegex.test(this.realZip)) {
        str = this.realZip.substring(0, this.realZip.length - 1);
        this.realZip = str
      }
    },
    realCity() {
      let str = "";
      if (!this.validRegexComma.test(this.realCity)) {
        str = this.realCity.substring(0, this.realCity.length - 1);
        this.realCity = str
      }
    },
    realNumeroApreciare() {
      let str = "";
      if (!this.validRegex.test(this.realNumeroApreciare)) {
        str = this.realNumeroApreciare.substring(0, this.realNumeroApreciare.length - 1);
        this.realNumeroApreciare = str
      }
    },
    realNumeroFiesta() {
      let str = "";
      if (!this.validRegex.test(this.realNumeroFiesta)) {
        str = this.realNumeroFiesta.substring(0, this.realNumeroFiesta.length - 1);
        this.realNumeroFiesta = str
      }
    },
    realNumeroEmple() {
      let str = "";
      if (!this.validRegexEMPLE.test(this.realNumeroEmple)) {
        str = this.realNumeroEmple.substring(0, this.realNumeroEmple.length - 1);
        this.realNumeroEmple = str
      }
    },
    mailContacto() {
      if (this.mailContactoConfirm != "") {
        if (this.mailContactoConfirm == this.mailContacto) {
          this.emailMatch = true
        } else {
          this.emailMatch = false
        }
      } if (this.mailContactoConfirm == "" && this.mailContacto == "") {
        this.emailMatch = true
      }



    },
    mailContactoConfirm() {
      if (this.mailContactoConfirm == this.mailContacto) {
        this.emailMatch = true
      } else {
        this.emailMatch = false
      }
      if (this.mailContactoConfirm == "" && this.mailContacto == "") {
        this.emailMatch = true
      }
    },
    getLanguage() {
      if (this.getLanguage == "es") {
        this.buttonSave = "Crear nuevo perfil"
        this.fields[1].label = "Nombre de perfil"
        if (!this.nuevoPerfil) {
          this.title = "Perfil de huéspedes"
        } else if (this.editingPerfil) {
          this.title = "Modificar perfil de huésped"
        } else {
          this.title = "Crear nuevo perfil de huésped"
        }
      } else if (this.getLanguage == "en") {
        this.buttonSave = "Create new profile"
        this.fields[1].label = "Profile name"
        if (!this.nuevoPerfil) {
          this.title = "Guests profile"
        } else if (this.editingPerfil) {
          this.title = "Modify guest profile"
        } else {
          this.title = "Create new guest profile"
        }
      }
    },
    pickedTelelefono() {
      
      //KB47296 Start
      console.log("@pickedTelelefono")
      switch (this.pickedTelelefono) {
        case "MOB":
          if (this.cellNumber !== "") {
            this.infoPersonal.numTelefonicoOficina = this.cellNumber
          }
          break;
        case "HOM":
          if (this.homeNumber !== "") {
            this.infoPersonal.numTelefonicoOficina = this.homeNumber
          }
          break;
        case "BUS":
          if (this.officeNumber !== "") {
            this.infoPersonal.numTelefonicoOficina = this.officeNumber
          }
          break;
        default:
          break;
      }

      this.isDisabledContacto;

      const auxPhoneNumber = this.infoPersonal.nationalNumber ? this.infoPersonal.nationalNumber : this.infoPersonal.numTelefonicoOficina;
      if(this.infoPersonal.areaCode && auxPhoneNumber){
        this.infoPersonal.numTelefonicoOficina = validatePhoneNumber(this.infoPersonal.areaCode, auxPhoneNumber, this.pickedTelelefono);
      }else{
        this.infoPersonal.areaCode = "+52";
        this.infoPersonal.numTelefonicoOficina = validatePhoneNumber(this.infoPersonal.areaCode, auxPhoneNumber, this.pickedTelelefono);
      }
      //KB47296 End

    },
    filterSearch() {
      if (this.filterSearch != "" && this.filterSearch != null) {
        this.currentPage = 1
      }
    },
    selectedGuestProfileId() {
      for (var i = 0; i < this.infoPersonal.perfiles.length; i++) {
        if (this.infoPersonal.perfiles[i].guestProfileId == this.selectedGuestProfileId) {
          this.chargeProfile(this.infoPersonal.perfiles[i])
        }
      }
    }
  },
  computed: {
    getLanguage() {
      return this.$store.getters.gettingLang
    },
    filteredListPerfiles() {
      return this.infoPersonal.perfiles.filter(perfil => {
        return perfil.nombre.toLowerCase().includes(this.infoPersonal.perfilDado
          .toLowerCase())
      })
    },
    isDisabledEstado() {
      if (this.banSelectedPais) {
        return false;
      } else {
        return true;
      }
    },
    rows() {
      return this.items.length;
    },
    filtered() {
      this.filterSearch = this.filters.name
      const filtered = this.items.filter(item => {
        return Object.keys(this.filters).every(key =>
          String(item[key].toLowerCase()).includes(this.filters[key].toLowerCase())
        );
      });
      return filtered.length > 0 ? filtered : []
    },
    filteredListTitulos() {
      return this.infoPersonal.titulos.filter(titulo => {
        return titulo.nombre
          .toLowerCase()
          .includes(this.infoPersonal.tituloDado.toLowerCase());
      });
    },
    filteredListPaises() {
      return this.infoPersonal.paises.filter(pais => {
        return pais.nombre
          .toLowerCase()
          .includes(this.realCountry.toLowerCase());
      });
    },
    filteredListEstado() {
      return this.infoPersonal.estados.filter(estado => {
        return estado.nombre
          .toLowerCase()
          .includes(this.infoPersonal.estadoSeleccionado.toLowerCase());
      });
    },
    // Validador
    isDisabledPersonales() {
      if (this.realNome.length >= 1 &&
        this.realApelhedo.length >= 1) {
        return false;
      } else {
        return true;
      }
    },
    isDisabledContacto() {

      console.log("@isDisabledContacto")
      
      if(this.infoPersonal.areaCode && !this.infoPersonal.nationalNumber){
        this.infoPersonal.nationalNumber = this.infoPersonal.numTelefonicoOficina
      }
      let phoneLength = 10
      if(this.infoPersonal.nationalNumber && this.infoPersonal.nationalNumber.startsWith("1")){
        phoneLength = 11;
      }

      if (
        !this.isDisabledPersonales &&
        this.pickedTelelefono.length > 2 &&
        this.infoPersonal.numTelefonicoOficina &&
        this.mailContacto.length > 3 && this.banSelectedPais
        && this.validateEmail(this.mailContacto) && (this.validateEmail(this.infoPersonal.mailContactoConfirmacion) || this.infoPersonal.mailContactoConfirmacion == "")
        && this.mailContactoConfirm.length > 3 && this.validateEmail(this.mailContactoConfirm) && this.emailMatch
        && this.countryCode.length != 0 
        && this.infoPersonal.areaCode && this.infoPersonal.nationalNumber && this.infoPersonal.nationalNumber.length >= phoneLength
      ) {
        return false;
      } else {
        return true;
      }
    },
  },
  filters: {
    resalt: function (value, valueFromSearch) {
      if (!value) return ''
      valueFromSearch != '' ? value = value.replace(valueFromSearch, '<span class="PC-text--semibold PC-color--colorBase2">' + valueFromSearch + '</span>') : value = value;
      return value;
    }
  },
  created() {
    if (!GlobalFunctions.validIfGenericUser()) {
      this.getCountries()
    }
  },
  methods: {
    servieUserDetailResult(data) {
      var payload = {
        userId: this.ls.get('Profile').data.username,
        clientId: this.ls.get('clientIdAdd').data.toUpperCase()
      }
      GlobalServices._userDetailsResults(this.ls.get('Token').data, this.ls.get('Language').data, payload).then(respon => {
        this.profileId = respon.data.profile.profileId;
        for (let listD of data) {
          if (listD.all.guestProfileId == this.profileId) {
            listD.visible = false;
          }
        }
      }).catch(error => {
        if ((error.status == 404 && (error.errorCode == "RSP_LIFERAY_PARSE_01" || error.errorCode == "RSP_LIFERAY_PARSE_02")) || error.status == 500 || error.status == 502 || error.status == 503 || error.status == 504) {
          this.$router.push({ name: "Error" });
        }
        if (error.status === 401) {
          this.clearLocalStorage();
        }
      });
    },
    resetSelectedPais() {
      this.banSelectedPais = false;
      this.infoPersonal.estadoSeleccionado = '';
      this.stateCode = '';
    },
    validateEmail(email) {
      const regex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return regex.test(email);
    },
    chargeProfile(res) {
      this.realNome = res.mainNameForService
      this.realApelhedo = res.fatherSurname
      this.realApelhedoMae = res.motherSurname
      this.realNumeroEmple = res.agentNumber
      this.realNumeroFiesta = res.fiestaRewardsNumber
      this.realNumeroApreciare = res.apreciation
      this.realNumeroCentro = res.costCenter
      //  PHONE
      this.pickedTelelefono = ""
      this.cellNumber = ""
      this.infoPersonal.numTelefonico = ""
      this.homeNumber = ""
      this.officeNumber = ""
      if (res.phone != null && res.phone.length != 0) {
        for (var i = 0; i < res.phone.length; i++) {
          if (res.phone[i].type == "MOB") {
            if (res.phone[i].number != null) {
              this.pickedTelelefono = 'MOB'
              this.cellNumber = res.phone[i].number
              this.infoPersonal.numTelefonico = res.phone[i].number
            }
          }
          if (res.phone[i].type == "HOM") {
            if (res.phone[i].number != null) {
              this.pickedTelelefono = 'HOM'
              this.homeNumber = res.phone[i].number
              this.infoPersonal.numTelefonico = res.phone[i].number
            }
          }
          if (res.phone[i].type == "BUS") {
            if (res.phone[i].number != null) {
              this.pickedTelelefono = 'BUS'
              this.officeNumber = res.phone[i].number
              this.infoPersonal.numTelefonico = res.phone[i].number
            }
          }
        }
      }
      // PHONE
      this.mailContacto = res.mailContacto
      this.mailContactoConfirm = res.mailContacto
      this.infoPersonal.mailContactoConfirmacion = res.emailAlternative != null ? res.emailAlternative : ""
      this.realAddress = res.streetNameWithNumber
      this.realTown = res.colony
      this.realZip = res.zipCode
      this.realCity = res.locality
      for (var i = 0; i < this.infoPersonal.paises.length; i++) {
        if (res.country == this.infoPersonal.paises[i].countryCode) {
          this.realCountry = this.infoPersonal.paises[i].nombre
          this.countryCode = this.infoPersonal.paises[i].countryCode
        }
      }
      for (var i = 0; i < this.infoPersonal.estados.length; i++) {
        if (res.state == this.infoPersonal.estados[i].stateCode) {
          this.infoPersonal.estadoSeleccionado = this.infoPersonal.estados[i].nombre
          this.stateCode = this.infoPersonal.estados[i].stateCode
        }
      }
    },
    cambiaPerfil(perfil, listaPerfil) {
      this.selectedGuestProfileId = listaPerfil.guestProfileId
      return this.infoPersonal.perfilDado = perfil;
    },
    outsidePerfil(e) {
      this.infoPersonal.perfil = false;
    },
    avisoPrivacidad() {
      (this.ls.get('Language').data == 'es' ? window.open(process.env.VUE_APP_POLICIES, '_blank') : window.open(process.env.VUE_APP_POLICIESEN, '_blank'));
    },
    updateValue(event) {
      const value = event.target.value
      if (String(value).length <= 10) {
        this.infoPersonal.numTelefonicoOficina = value
      }
      this.$forceUpdate()
    },
    cambiaEstado(state) {
      for (var i = 0; i < this.infoPersonal.estados.length; i++) {
        if (state == this.infoPersonal.estados[i].nombre) {
          this.stateCode = this.infoPersonal.estados[i].stateCode
        }
      }
      return this.infoPersonal.estadoSeleccionado = state
    },
    getStates(pais) {
      var codeCountry = ""
      this.countryCode = ""

      for (var i = 0; i < this.infoPersonal.paises.length; i++) {
        if (this.infoPersonal.paises[i].nombre == pais) {
          codeCountry = this.infoPersonal.paises[i].countryCode
          this.countryCode = codeCountry

        }
      }
      axios.get(process.env.VUE_APP_HOSTCORPORATEAPI + process.env.VUE_APP_CORPORATEAPI + process.env.VUE_APP_COUNTRY + `/${codeCountry}/` + process.env.VUE_APP_STATE,
        {
          withCredentials: true,
          credentials: 'include',
          headers: {
            Authorization: "Bearer " + this.ls.get("Token").data,
            "Accept-Language": this.ls.get("Language").data,
            'Content-Type': 'application/json'
          }
        })
        .then(res => {
          var resObject = JSON.parse(JSON.stringify(res));
          if (resObject.status == 200 || resObject.status == 201) {
            var intermidiate = resObject.data.response
            var intermidiate2 = []
            this.infoPersonal.estados = []
            for (var i = 0; i < intermidiate.length; i++) {
              intermidiate2.push({ 'nombre': intermidiate[i].stateName, 'stateCode': intermidiate[i].stateCode })
            }
            this.infoPersonal.estados = intermidiate2
          } else {
          }
        })
        .catch(error => {
          // Error server
          if ((error.response.status == 404 && (error.response.data.errorCode == "RSP_LIFERAY_PARSE_01" || error.response.data.errorCode == "RSP_LIFERAY_PARSE_02")) || error.response.status == 500 || error.response.status == 502 || error.response.status == 503 || error.response.status == 504) {
            this.$router.push({ name: "Error" });
          }
          // Error server 
          let errorObject = JSON.parse(JSON.stringify(error));
          if (errorObject.message == 'Request failed with status code 401') {
            this.clearLocalStorage()
          }
        })
      // Fin de consultar estados
    },
    cambiaTitulo(titulo) {
      for (var i = 0; i < this.infoPersonal.titulos.length; i++) {
        if (titulo == this.infoPersonal.titulos[i].nombre) {
          this.titleCode = this.infoPersonal.titulos[i].value
        }
      }
      return this.infoPersonal.tituloDado = titulo
    },
    cambiaPais(pais) {
      this.banSelectedPais = true;
      for (var i = 0; i < this.infoPersonal.paises.length; i++) {
        if (pais == this.infoPersonal.paises[i].nombre) {
          this.countryCode = this.infoPersonal.paises[i].countryCode
        }
      }
      this.getStates(pais)
      return this.realCountry = pais
    },
    getCountries() {
      // Consultar paises
      axios.get(process.env.VUE_APP_HOSTCORPORATEAPI + process.env.VUE_APP_CORPORATEAPI + process.env.VUE_APP_COUNTRY,
        {
          withCredentials: true,
          credentials: 'include',
          headers: {
            Authorization: "Bearer " + this.ls.get("Token").data,
            "Accept-Language": this.ls.get("Language").data,
            'Content-Type': 'application/json'
          }
        })
        .then(res => {
          var resObject = JSON.parse(JSON.stringify(res));
          if (resObject.status == 200 || resObject.status == 201) {
            var intermidiate = resObject.data.response
            var intermidiate2 = []
            this.infoPersonal.paises = []
            for (var i = 0; i < intermidiate.length; i++) {
              intermidiate2.push({ 'nombre': intermidiate[i].countryName, 'countryCode': intermidiate[i].countryCode })
            }
            this.infoPersonal.paises = intermidiate2
          }
        })
        .catch(error => {
          // Error server
          if ((error.response.status == 404 && (error.response.data.errorCode == "RSP_LIFERAY_PARSE_01" || error.response.data.errorCode == "RSP_LIFERAY_PARSE_02")) || error.response.status == 500 || error.response.status == 502 || error.response.status == 503 || error.response.status == 504) {
            this.$router.push({ name: "Error" });
          }
          // Error server 
          let errorObject = JSON.parse(JSON.stringify(error));
          if (errorObject.message == 'Request failed with status code 401') {
            this.clearLocalStorage()
          } else {
          }
        })
      // Fin de consultar paises

    },
    closeExpiredModal() {
      this.isExpiredModalVisible = false;
      var ls = new SecureLS({ encodingType: "aes" });
      GlobalFunctions.localStorageClean();
      this.$router.push({ name: "Login" });
    },
    clearLocalStorage() {
      this.isExpiredModalVisible = true;
    },
    dataTable() {
      var _this = this;
      this.enableLoaderTable = true

      axios
        .get(
          process.env.VUE_APP_HOSTCORPORATEAPI +
          process.env.VUE_APP_CORPORATEAPI +
          process.env.VUE_APP_GUEST +
          `${this.ls.get("Profile").data.profileType}`,
          {
            withCredentials: true,
            credentials: "include",
            headers: {
              Authorization: "Bearer " + this.ls.get("Token").data,
              "Accept-Language": this.ls.get("Language").data,
              "Content-Type": "application/json"
            }
          }
        )
        .then(response => {
          this.guestsWS = response.data.response;
          var data = [];
          var respuesta = response.data.response;
          Object.keys(respuesta).forEach(key => {
            var nam = respuesta[key].name;
            var sam = "";
            var em = "";
            sam = nam.concat(" " + respuesta[key].fatherSurname)
            em = sam
            if (
              respuesta[key].motherSurname != null &&
              respuesta[key].motherSurname != ""
            ) {
              em = em.concat(" " + respuesta[key].motherSurname)
            }
            data.push({
              name: em,
              all: respuesta[key],
              visible: true,
              index: key
            });
          });
          _this.items = data;
          this.servieUserDetailResult(data);
          this.enableLoaderTable = false
        })
        .catch(error => {
          this.enableLoaderTable = false
          // Error server
          let errorObject = JSON.parse(JSON.stringify(error));
          if (errorObject.message == 'Network Error' || (error.response.status < 600 && error.response.status > 403) || (error.response.status < 399 && error.response.status > 299) || error.response.status < 200) {
            this.$router.push({ name: "Error" });


          }
          // Error server 

          if (errorObject.message == "Request failed with status code 401") {
            this.clearLocalStorage();
          }
        });
    },
    // Control de selección de tabla
    onRowSelected(items) {
      for (let i = 0; i < items.length; i++) {
        if (this.profileId == items[i].all.guestProfileId) {
          setTimeout(() => {
            this.$refs.selectableTable.unselectRow(+items[i].index);
          }, 1);
        }
      }
      this.selected = items;
    },
    selectAllRows() {
      this.$refs.selectableTable.selectAllRows();
    },
    UnselectAllRows() {
      this.$refs.selectableTable.clearSelected();
    },
    outsideTitulo(e) {
      this.infoPersonal.titulo = false;
    },
    outsidePais(e) {
      this.infoPersonal.pais = false;
    },
    outsideEstado(e) {
      this.infoPersonal.estado = false;
    },
    showModalGuardar() {
      this.isModalGuardar = true;
      this.dataTable()
    },
    closeModalGuardar() {
      this.isModalGuardar = false;
    },
    showModalEliminar(profile) {
      this.isModalEliminar = true;
      this.curProfile.push(profile.item.all.guestProfileId)
    },
    closeModalEliminar() {
      this.isModalEliminar = false;
    },
    closeModalEliminarI(one, two) {
      axios
        .post(
          process.env.VUE_APP_HOSTCORPORATEAPI +
          process.env.VUE_APP_CORPORATEAPI +
          process.env.VUE_APP_DEPRO
          , {
            "profileIdList": this.curProfile
          },
          {
            withCredentials: true,
            credentials: "include",
            headers: {
              Authorization: "Bearer " + this.ls.get("Token").data,
              "Accept-Language": this.ls.get("Language").data,
              "Content-Type": "application/json"
            }
          }
        )
        .then(response => {
          for (var i = 0; i < this.items.length; i++) {
            for (var j = 0; j < this.curProfile.length; j++) {
              if (this.items[i].all.guestProfileId == this.curProfile[j]) {
                this.items.splice(i, 1);
              }
            }
          }
          this.isModalEliminar = false;
          this.isModalConfirmacionEliminar = one
          this.isModalConfirmMultiDelete = two
          this.curProfile = []
        })
        .catch(error => {
          this.curProfile = []
          // Error server
          let errorObject = JSON.parse(JSON.stringify(error));
          if (errorObject.message == 'Network Error' || (error.response.status < 600 && error.response.status > 403) || (error.response.status < 399 && error.response.status > 299) || error.response.status < 200) {

            this.$router.push({ name: "Error" });


          }
          // Error server 

          if (errorObject.message == "Request failed with status code 401") {
            this.clearLocalStorage();
          } else {
          }
        });
    },
    showModalMultiDelete() {
      for (var i = 0; i < this.selected.length; i++) {
        this.curProfile.push(this.selected[i].all.guestProfileId)
      }
      this.isModalMultiDelete = true;
    },
    closeModalMultiDelete() {
      this.closeModalEliminarI(false, true)
      this.isModalMultiDelete = false;

    },
    showModalConfirmMultiDelete() {
      this.isModalConfirmMultiDelete = true;
    },
    closeModalConfirmMultiDelete() {
      this.isModalConfirmMultiDelete = false;
      // Método para actualizar la tabla
      this.$refs.selectableTable.refresh();
    },
    closeModalConfirmacionEliminar() {
      this.isModalConfirmacionEliminar = false;
    },
    CrearNuevoPerfil() {
      this.clearForm()
      this.readyUpdate = false,
        this.nuevoPerfil = true;
      this.title = i18n.t('language.posadasCorporate.perfilHuespedes.txt1');
      this.buttonSave = i18n.t('language.posadasCorporate.perfilHuespedes.crearNuePerfil');
      this.modalTitle = i18n.t('language.posadasCorporate.perfilHuespedes.modalGuardar.body1');
      this.modalBody = i18n.t('language.posadasCorporate.perfilHuespedes.modalGuardar.title2');
    },
    modificarPerfil(profileData) {
      this.mailContacto = ""
      this.mailContactoConfirm = ""
      this.profileIdR = profileData.item.all.guestProfileId
      // Get data to populate edition form
      axios.post(process.env.VUE_APP_HOSTCORPORATEAPI + process.env.VUE_APP_CORPORATEAPI + process.env.VUE_APP_PERHUES, {
        "guestProfileId": profileData.item.all.guestProfileId,
        "fiestaRewardsNumber": profileData.item.all.fiestaRewardsNumber
      }, {
        withCredentials: true,
        credentials: "include",
        headers: {
          Authorization: "Bearer " + this.ls.get("Token").data,
          "Content-Type": "application/json",
          "Accept-Language": this.ls.get("Language").data
        }
      })
        .then(res => {
          // Personal data
          this.realNome = res.data.response.name
          this.realApelhedo = res.data.response.fatherSurname
          this.realApelhedoMae = res.data.response.motherSurname
          this.realNumeroEmple = res.data.response.employeeNumber
          this.realNumeroFiesta = res.data.response.fiestaRewardsNumber
          this.realNumeroApreciare = res.data.response.apreciareClubNumber
          this.realNumeroCentro = res.data.response.costCenter
          //  PHONE
          if (res.data.response.phone != null && res.data.response.phone.length != 0) {
            for (var i = 0; i < res.data.response.phone.length; i++) {
              if (res.data.response.phone[i].type == "MOB") {
                if (res.data.response.phone[i].number != null) {
                  this.pickedTelelefono = 'MOB'
                  this.cellNumber = res.data.response.phone[i].number
                  this.infoPersonal.numTelefonico = res.data.response.phone[i].number
                }
              }
              if (res.data.response.phone[i].type == "HOM") {
                if (res.data.response.phone[i].number != null) {
                  this.pickedTelelefono = 'HOM'
                  this.homeNumber = res.data.response.phone[i].number
                  this.infoPersonal.numTelefonico = res.data.response.phone[i].number
                }
              }
              if (res.data.response.phone[i].type == "BUS") {
                if (res.data.response.phone[i].number != null) {
                  this.pickedTelelefono = 'BUS'
                  this.officeNumber = res.data.response.phone[i].number
                  this.infoPersonal.numTelefonico = res.data.response.phone[i].number
                }
              }
            }
          }
          // PHONE

          this.mailContacto = res.data.response.email
          this.mailContactoConfirm = res.data.response.email

          this.infoPersonal.mailContactoConfirmacion = res.data.response.emailAlternative != null ? res.data.response.emailAlternative : ""
          this.realAddress = res.data.response.address.streetNameWithNumber
          this.realTown = res.data.response.address.colony
          this.realZip = res.data.response.address.zipCode
          this.realCity = res.data.response.address.locality

          this.realCountry = res.data.response.address.country
          if (this.realCountry != null && this.realCountry != '') {
            this.banSelectedPais = true;
          }
          this.infoPersonal.estadoSeleccionado = res.data.response.address.state
          this.paisSeleccionado = res.data.response.address.country
          this.estadoSeleccionado = res.data.response.address.state
          for (var i = 0; i < this.infoPersonal.paises.length; i++) {
            if (this.paisSeleccionado == this.infoPersonal.paises[i].countryCode) {
              this.realCountry = this.infoPersonal.paises[i].nombre
              this.countryCode = this.infoPersonal.paises[i].countryCode
              this.getStates(this.infoPersonal.paises[i].nombre);


            }
          }
          this.extEditPerfil(res.data.response.address.country, res.data.response.address.state);
          // Address Type is yet put-off
        })
        .catch(error => {
          // Error server
          let errorObject = JSON.parse(JSON.stringify(error));
          if (errorObject.message == 'Network Error' || (error.response.status < 600 && error.response.status > 403) || (error.response.status < 399 && error.response.status > 299) || error.response.status < 200) {

            this.$router.push({ name: "Error" });


          }
          // Error server 

          if (errorObject.message == 'Request failed with status code 401') {
            this.clearLocalStorage()
          }

          // Fin de consultar estados

        })

      // WS to update

      // Integrate previous steps with this original following code


      this.nuevoPerfil = true;
      this.editingPerfil = true;
      this.title = i18n.t('language.posadasCorporate.perfilHuespedes.txt2');
      this.buttonSave = i18n.t('language.posadasCorporate.perfilHuespedes.guarMod');
      this.modalTitle = i18n.t('language.posadasCorporate.perfilHuespedes.modalGuardar.title1');
      this.modalBody = i18n.t('language.posadasCorporate.perfilHuespedes.modalGuardar.body2');
    },

    //KB47296 Start
    handleValidatePhoneNumber(phoneObject){
      console.log("@handleValidatePhoneNumber");
      console.log(phoneObject);

      this.isDisabledContacto;
      if(phoneObject.countryCallingCode && phoneObject.nationalNumber){
        this.infoPersonal.areaCode = '+' + phoneObject.countryCallingCode;
        this.infoPersonal.nationalNumber = phoneObject.nationalNumber;
        this.handleCountryChanged({dialCode: phoneObject.countryCallingCode});
      }

      if(this.infoPersonal.nationalNumber === "" && this.infoPersonal.areaCode === ""){
        this.infoPersonal.numTelefonicoOficina = ""
      }
      
    },
    handleOnBlurPhoneNumber() {
      console.log("@handleOnBlurPhoneNumber");
      this.isDisabledContacto;
      if(this.infoPersonal.areaCode && this.infoPersonal.nationalNumber){
        this.infoPersonal.numTelefonicoOficina = validatePhoneNumber(this.infoPersonal.areaCode, this.infoPersonal.nationalNumber, this.pickedTelelefono);
        this.forceRerender();
      }
      
    },
    handleCountryChanged(countryObject) {
      console.log("@handleCountryChanged");
      console.log(countryObject);

      this.isDisabledContacto;
      if(countryObject.dialCode){
        this.infoPersonal.areaCode = '+' + countryObject.dialCode;
      }

      if(this.infoPersonal.areaCode && this.infoPersonal.nationalNumber){
        this.infoPersonal.numTelefonicoOficina = validatePhoneNumber(this.infoPersonal.areaCode, this.infoPersonal.nationalNumber, this.pickedTelelefono);
      }
      
    },
    handleOnInputPhoneNumber(number, phoneObject) {
      console.log("@handleOnInputPhoneNumber");
      console.log(number);
      console.log(phoneObject);

      if(phoneObject.countryCallingCode && phoneObject.nationalNumber){
        this.infoPersonal.areaCode = '+' + phoneObject.countryCallingCode;
        this.infoPersonal.nationalNumber = phoneObject.nationalNumber;
      }

      if(number === ""){
        this.infoPersonal.areaCode = "";
        this.infoPersonal.nationalNumber = "";
        this.infoPersonal.numTelefonicoOficina = "";
      }

      this.isDisabledContacto;

    },
    forceRerender() {
      this.telInput += 1;
    },
    //KB47296 End

    extEditPerfil(country, state) {
      if (country != null && country != undefined && country != '') {
        if (this.infoPersonal.estados.length > 0) {
          for (var i = 0; i < this.infoPersonal.estados.length; i++) {
            if (state == this.infoPersonal.estados[i].stateCode) {
              this.infoPersonal.estadoSeleccionado = this.infoPersonal.estados[i].nombre
              this.stateCode = state
            }
          }
        } else {
          setTimeout(() => {
            this.extEditPerfil(country, state);
          }, 500);
        }
      }
    },
    newProfile() {
      axios
        .post(
          process.env.VUE_APP_HOSTCORPORATEAPI +
          process.env.VUE_APP_CORPORATEAPI +
          process.env.VUE_APP_CREPRO,
          {
            lastName2: this.realApelhedoMae.toUpperCase(),
            profileType: this.tipoperfilCheck,
            title: this.infoPersonal.tituloDado,
            firstName: this.realNome.toUpperCase(),
            middleName: "",
            lastName: this.realApelhedo.toUpperCase(),
            numerFiestaRewards: this.realNumeroFiesta.toUpperCase(),
            numberAprecieClub: this.realNumeroApreciare.toUpperCase(),
            centerCost: this.realNumeroCentro.toUpperCase(),
            numberEmployee: this.realNumeroEmple.toUpperCase(),
            direction: {
              streetAndNumber: this.realAddress.toUpperCase(),
              colony: this.realTown.toUpperCase(),
              zip: this.realZip.toUpperCase(),
            },
            state: this.stateCode,
            country: this.countryCode,
            city: this.realCity.toUpperCase(),
            phoneNumber: this.infoPersonal.numTelefonicoOficina,
            phoneType: this.pickedTelelefono,
            email: this.mailContacto,
            emailAlternative: this.infoPersonal.mailContactoConfirmacion,
            preferences: []
          },
          {
            withCredentials: true,
            credentials: "include",
            headers: {
              Authorization: "Bearer " + this.ls.get("Token").data,
              "Content-Type": "application/json",
              "Accept-Language": this.ls.get("Language").data
            }
          }
        )
        .then(res => {
          var resObject = JSON.parse(JSON.stringify(res));
          this.enableLoader = false
          this.resetState()
        })
        .catch(error => {
          this.enableLoader = false
          // Error server
          let errorObject = JSON.parse(JSON.stringify(error));
          if (errorObject.message == 'Network Error' || (error.response.status < 600 && error.response.status > 403) || (error.response.status < 399 && error.response.status > 299) || error.response.status < 200) {

            this.$router.push({ name: "Error" });


          }
          // Error server 

          if (errorObject.message == "Request failed with status code 401") {
            this.clearLocalStorage();
          }
        });
    },
    updatePr() {
      axios
        .post(
          process.env.VUE_APP_HOSTCORPORATEAPI +
          process.env.VUE_APP_CORPORATEAPI +
          process.env.VUE_APP_UPPRO,
          {
            "profileId": this.profileIdR,
            lastName2: this.realApelhedoMae.toUpperCase(),
            profileType: this.tipoperfilCheck,
            title: this.infoPersonal.tituloDado,
            firstName: this.realNome.toUpperCase(),
            middleName: "",
            lastName: this.realApelhedo.toUpperCase(),
            numerFiestaRewards: this.realNumeroFiesta.toUpperCase(),
            numberAprecieClub: this.realNumeroApreciare.toUpperCase(),
            centerCost: this.realNumeroCentro.toUpperCase(),
            numberEmployee: this.realNumeroEmple.toUpperCase(),
            direction: {
              streetAndNumber: this.realAddress.toUpperCase(),
              colony: this.realTown.toUpperCase(),
              zip: this.realZip.toUpperCase(),
            },
            country: this.countryCode,
            city: this.realCity.toUpperCase(),
            state: this.stateCode,
            phoneNumber: this.infoPersonal.numTelefonicoOficina,
            phoneType: this.pickedTelelefono,
            email: this.mailContacto,
            emailAlternative: this.infoPersonal.mailContactoConfirmacion,
            preferences: []
          },
          {
            withCredentials: true,
            credentials: "include",
            headers: {
              Authorization: "Bearer " + this.ls.get("Token").data,
              "Content-Type": "application/json",
              "Accept-Language": this.ls.get("Language").data
            }
          }
        )
        .then(res => {
          var resObject = JSON.parse(JSON.stringify(res));
          this.enableLoader = false
          this.resetState()
        })
        .catch(error => {
          // Error server
          this.enableLoader = false

          let errorObject = JSON.parse(JSON.stringify(error));
          if (errorObject.message == 'Network Error' || (error.response.status < 600 && error.response.status > 403) || (error.response.status < 399 && error.response.status > 299) || error.response.status < 200) {

            this.$router.push({ name: "Error" });


          }
          // Error server 

          if (errorObject.message == "Request failed with status code 401") {
            this.clearLocalStorage();
          }
        });
    },
    createNewProfile() {
      this.enableLoader = true
      if (this.readyUpdate) {
        this.updatePr()
      } else {
        this.newProfile()
      }
    },
    clearForm() {
      this.cellNumber = ""
      this.homeNumber = ""
      this.officeNumber = ""
      this.selectedGuestProfileId = ""
      this.realCountry = ""
      this.infoPersonal.estadoSeleccionado = ""
      this.pickedTelelefono = ""
      this.realApelhedoMae = ""
      this.infoPersonal.pickedDireccion = ""
      this.tipoperfilCheck = ""
      this.infoPersonal.tituloDado = ""
      this.realNome = ""
      this.realApelhedo = ""
      this.realNumeroFiesta = ""
      this.realNumeroApreciare = ""
      this.realNumeroCentro = ""
      this.realNumeroEmple = ""
      this.realAddress = ""
      this.realTown = ""
      this.realZip = ""
      this.stateCode = ""
      this.countryCode = ""
      this.realCity = ""
      this.infoPersonal.numTelefonicoCasa = ""
      this.infoPersonal.numTelefonicoOficina = ""
      //KB47296 Start
      this.infoPersonal.areaCode = ""
      this.infoPersonal.nationalNumber = ""
      //KB47296 End
      this.infoPersonal.numTelefonicoCel = ""
      this.mailContacto = ""
      this.mailContactoConfirm = ""
      this.emailMatch = true
      this.infoPersonal.mailContactoConfirmacion = ""
      this.infoPersonal.tipoPerfil = true;
      this.infoPersonal.datosPersonales = true;
      this.infoPersonal.datosContacto = true;
      this.visible = true;
      this.nuevoPerfil = false;
      this.paisSeleccionado = ""

    },
    resetState() {
      this.infoPersonal.tipoPerfil = true;
      this.infoPersonal.datosPersonales = true;
      this.infoPersonal.datosContacto = true;
      this.visible = true;
      this.nuevoPerfil = false;
      this.editingPerfil = false
      this.title = i18n.t('language.posadasCorporate.perfilHuespedes.perfilHuespedes');
      this.clearForm()
      this.showModalGuardar();
    },

  },
  filters: {
    resalt: function (value, valueFromSearch) {
      if (!value) return ''
      valueFromSearch != '' ? value = value.replace(valueFromSearch,
        '<span class="PC-text--semibold PC-color--colorBase2">' + valueFromSearch + '</span>'
      ) : value = value;
      return value;
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../../assets/scss/config.scss";

.inputUppercase {
  text-transform: uppercase;
}

.padding-custom {
  padding-top: 115px;
  padding-bottom: 80px;
}

.custom-inputsearch {
  position: relative;
  text-align: right;
  padding-bottom: 25px;

  input {
    border-radius: 4px;
    border: solid 1px #bac9d8;
    padding: 8px;
    height: 34px;
    min-width: 230px;
  }

  i {
    position: absolute;
    right: 5px;
    top: 5px;
    font-size: 18px;
    color: #005a83;
    height: 34px;
  }
}

.icon-none {
  margin-left: 24px;
}

#selected,
#options {
  display: none;
}

.relative {
  position: relative;
}

.custom-ml-5 {
  margin-left: 5px;

  @media (max-width: 991px) {
    margin-left: 0;
  }
}

.custom-ml-35 {
  margin-left: 35px;

  @media (max-width: 991px) {
    margin-left: 0;
  }
}

.custom-ml-50 {
  margin-left: 50px;

  @media (max-width: 991px) {
    margin-left: 0;
  }
}

.checkAll {
  position: absolute;
  top: 13px;
  left: 12px;
  font-size: 16px;
}

.multiDelete {
  position: absolute;
  top: 15px;
  right: 57px;

  @media (max-width: 1024px) {
    right: 40px;
  }

  @media (max-width: 768px) {
    right: 20px;
  }

  span {
    font-size: 16px;

    @media (max-width: 425px) {
      font-size: 14px;
    }
  }
}

.datos {
  i {
    font-size: 18px;
  }

  .navi {
    float: right;
  }

  .editarDatos {
    font-size: $font-size-base;
    color: #0c5458;
    float: right;
  }
}

.campos {
  border-bottom: 1px solid $colorBase5;

  &:last-child {
    border-bottom: none;
  }

  .datos {
    padding-bottom: 24px;
  }

  .tituloDatos {
    margin: 0;
    color: $grayBrownish;
    font-size: $font-size-large;
    font-weight: 500;
    padding-top: 24px;
    padding-bottom: 24px;
  }

  .camposActive {
    color: #0c5458;
    font-weight: 500;
  }

  .tituloDatosEditar {
    margin: 0;
    color: #006900;
    font-weight: 500;
    padding-top: 24px;
    padding-bottom: 24px;
  }
}

@media (min-width: 992px) {
  .datos {
    .botonesInfo {
      padding-top: 25px;
      left: 50%;
    }
  }
}

.botonesInfo {
  text-align: right;

  .button {
    max-width: 50%;

    @media (max-width: 991px) {
      max-width: 100%;
      width: 100%;
      margin-top: 20px;
    }
  }
}
</style>